import $ from 'jquery';
import { bind, scheduleOnce } from '@ember/runloop';
import Em from 'ember';
export default Em.Mixin.create({
  setupMutationObserverMixin: Em.on('didInsertElement', function () {
    if (typeof MutationObserver !== 'undefined') {
      let observer = new MutationObserver(bind(this, this.domDidMutate));
      let target = $(this.element)?.[0];
      if (target) {
        let config = {
          childList: true,
          characterData: true,
          subtree: true
        };
        observer.observe(target, config);
      }
      this.set('mutationObserver', observer);
    }
  }),
  destroyMutationObserver: Em.on('willDestroyElement', function () {
    this.get('mutationObserver')?.disconnect();
    this.set('mutationObserver', null);
  }),
  domDidMutate() {
    scheduleOnce('actions', this, this._domDidMutate);
  },
  _domDidMutate() {
    let originalHasAnyContent = this.get('hasAnyContent');
    this.checkForContent();
    let hasAnyContent = this.get('hasAnyContent');
    if (hasAnyContent || originalHasAnyContent) {
      this.sendChange();
    }
  }
});